import React from 'react';
import { FormattedMessage } from 'react-intl';

import BrowseButton from 'Components/Utility/BrowseButton';
import FranchiseImgGrid from 'Components/FacetSearch/FranchiseImgGrid';

const TopFranchises = () =>
  <section className="franchise-section container">
    <div className="section-heading-container">
      <h2 className="section-title">
        <FormattedMessage
          id="onsalesections.topfranchises"
          defaultMessage="Top Franchises"
        />
      </h2>
      <BrowseButton className={'view-all-btn'} location={'franchises'} />
    </div>
    <FranchiseImgGrid />
  </section>;

export default TopFranchises;
